import sortBy from "lodash/sortBy";
import type { UseSearchParamStateOptions } from "use-search-param-state";
import { useSearchParamState } from "use-search-param-state";

const separator = ".";
const options: UseSearchParamStateOptions<string[]> = {
  stringify: (v: string[]) => sortBy(v.filter((it) => it)).join(separator),
  parse: (v: string) => v.split(separator).filter((it) => it),
};
export function useSearchParamArray(paramName: string) {
  return useSearchParamState<string[]>(paramName, [], options);
}
